import { TabProps } from '@silverfort/sf-components/dist/Tabs/Tab';

export enum ActiveDirectoryAccessTab {
    Applications = 'Applications',
    Resources = 'Resources'
}

export const ActiveDirectoryAccessTabs: Array<TabProps<ActiveDirectoryAccessTab>> = [
    {
        name: 'Applications',
        value: ActiveDirectoryAccessTab.Applications
    },
    {
        name: 'Resources',
        value: ActiveDirectoryAccessTab.Resources
    }
];
